import {TransactionStatus} from '@sollapay/enums';
import {Icon, Typography} from '@sollapay/ui';
import {useTranslation} from 'react-i18next';

import {BaseTransactionRow} from './BaseTransactionRow';
import {PayoutDirectionBadge} from './PayoutDirectionBadge';

import type {TrustAccountPayoutTransactionDTO} from '@sollapay/types';
import type {FC} from 'react';

interface PayoutTransactionRowProps {
  transaction: TrustAccountPayoutTransactionDTO;
}

export const PayoutTransactionRow: FC<PayoutTransactionRowProps> = ({transaction}) => {
  const {t} = useTranslation('trustAccounts');
  const isInflight =
    transaction.status === TransactionStatus.INFLIGHT ||
    transaction.status === TransactionStatus.VOIDED;

  const creditorName = transaction.creditorName ?? t('view.transactions.payout');

  const directionIcon = (
    <Icon data-slot="direction-icon" name="sollapay:payout" className="size-8 shrink-0" />
  );

  const nameSection = (
    <>
      <Typography size="sm" weight="medium">
        {creditorName}
      </Typography>
      {transaction.description != null && (
        <Typography size="xs" color="tertiary">
          {transaction.description}
        </Typography>
      )}
    </>
  );

  return (
    <BaseTransactionRow
      directionIcon={directionIcon}
      nameSection={nameSection}
      badgeSection={<PayoutDirectionBadge />}
      status={transaction.status}
      effectiveDate={transaction.effectiveDate}
      amount={transaction.amount}
      isCredit={false}
      isInflight={isInflight}
      percent={undefined}
    />
  );
};
